import { FEATURE_FLAGS } from '../../../../featureFlags';
import Bot from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';
import store from 'dashboard/store';
import SettingsWrapper from '../SettingsWrapper.vue';

const requireInstallationSuperAdmin = (to, _from, next) => {
  if (store.getters.getCurrentUser?.type === 'SuperAdmin') {
    next();
    return;
  }

  const accountId = to.params.accountId ?? store.getters.getCurrentAccountId;
  if (!accountId) {
    next('/app/login');
    return;
  }

  next({
    path: frontendURL(`accounts/${accountId}/settings/general`),
  });
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agent-bots'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'agent_bots',
          component: Bot,
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_BOTS,
            permissions: ['administrator'],
          },
          beforeEnter: requireInstallationSuperAdmin,
        },
      ],
    },
  ],
};
